import Link from 'next/link';

import { Icon } from '@goed/ui-components';

import { ShoppingCartMenuItemProps } from '../PrimaryNavigation.types';

export const ShoppingCartCount: React.FC<ShoppingCartMenuItemProps> = ({
    count,
}: ShoppingCartMenuItemProps): JSX.Element => {
    if (!count) return <></>;

    return (
        <span className="shopping-cart__count" aria-label={`${count} producten in je winkelmandje`}>
            {count}
        </span>
    );
};

export const ShoppingCartLoader = () => {
    return (
        <span className="shopping-cart__count is-loader" aria-label={'We zijn je winkelmandje aan het aanpassen'}>
            <Icon name="loader" style={{ width: '1rem', height: '1rem' }} />
        </span>
    );
};

export const ShoppingCartMenuItem = () => {
    const isPending = false;
    const isFetching = false;

    const count = 0;
    const loading = isPending && isFetching;

    return (
        <Link href="/cart">
            <a className="shopping-cart" aria-label="Winkelmandje">
                <Icon name="shopping-basket" className="shopping-cart__icon" />
                {!loading && <ShoppingCartCount count={count} />}
                {loading && <ShoppingCartLoader />}
            </a>
        </Link>
    );
};
